var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { computed, action } from "mobx";
import { RacingStore, RacingEventTypes, RacingEventStatusType } from "../../../data";
import { LeagueEventsCompositeModel, BranchViewEventModel } from "../data";
export class RacingCurrentEventsData {
    constructor(provider, racingGameNavigation) {
        this.provider = provider;
        this.racingStore = RacingStore.getInstance;
        this.racingStore.webMethods = {
            pageMethods: provider.pageMethods,
            racingPageMethods: provider.racingPageMethods
        };
        this.racingGameNavigation = racingGameNavigation;
    }
    // TODO: Remove when new event view is available
    openRacingGame(racecardId, regionId, mode, branchId, trapMarketId, bettingWithoutFavId, bettingWithoutTwoFavId, placeOnlyId, matchBettingId, toteId, totePlaceOnlyId, auPlaceOnlyId, event) {
        this.racingGameNavigation(event, racecardId, regionId, mode, branchId, trapMarketId, bettingWithoutFavId, bettingWithoutTwoFavId, placeOnlyId, matchBettingId, toteId, totePlaceOnlyId, auPlaceOnlyId);
    }
    get branchViewLeagueEvents() {
        let sortedLeagues = this.racingStore.sortedLeagues;
        let branchViewLeaguesEventsArr = new Array();
        /* istanbul ignore next */
        for (let league of sortedLeagues) {
            let hasLiveStream = false;
            let masterEventsPerLeague = this.racingStore.filteredEventsByLeagueID(this.selectedType, league.masterLeagueId);
            /* istanbul ignore next */
            if (masterEventsPerLeague.length === 0) {
                continue;
            }
            let currBranchViewLeagueEvent = new LeagueEventsCompositeModel({ id: league.id, leagueName: league.name, hasLiveStream: false, events: [] });
            /* istanbul ignore next */
            for (let masterEvent of masterEventsPerLeague) {
                let currBranchViewEvent = new BranchViewEventModel({
                    id: masterEvent.id,
                    dateTime: masterEvent.date,
                    url: this.getUrl(masterEvent, league),
                    raceProgress: masterEvent.raceProgress,
                    handler: this.openRacingGame.bind(this, this.racingStore.getMasterEventSpecificEventType(masterEvent, RacingEventTypes.RaceCard), this.racingStore.regionId, this.selectedType, Number(this.racingStore.branch.id), this.racingStore.getMasterEventSpecificEventType(masterEvent, RacingEventTypes.TrapMarket), this.racingStore.getMasterEventSpecificEventType(masterEvent, RacingEventTypes.BettingWithoutFav), this.racingStore.getMasterEventSpecificEventType(masterEvent, RacingEventTypes.BettingWithoutTwoFav), this.racingStore.getMasterEventSpecificEventType(masterEvent, RacingEventTypes.PlaceOnly), this.racingStore.getMasterEventSpecificEventType(masterEvent, RacingEventTypes.MatchBetting), this.racingStore.getMasterEventSpecificEventType(masterEvent, RacingEventTypes.AUHRTote), this.racingStore.getMasterEventSpecificEventType(masterEvent, RacingEventTypes.AUHRTotePlaceOnly), this.racingStore.getMasterEventSpecificEventType(masterEvent, RacingEventTypes.AUHRPlaceOnly))
                });
                currBranchViewLeagueEvent.events.push(currBranchViewEvent);
                hasLiveStream = hasLiveStream || masterEvent.racingEvents.some(this.hasLiveStream);
            }
            currBranchViewLeagueEvent.hasLiveStream = hasLiveStream;
            branchViewLeaguesEventsArr.push(currBranchViewLeagueEvent);
        }
        return branchViewLeaguesEventsArr;
    }
    getUrl(masterEvent, league) {
        return masterEvent.raceProgress !== RacingEventStatusType.IsResult
            ? this.racingStore.getMasterRacingEventUrl(masterEvent, league)
            : "javascript:void();";
    }
    /* istanbul ignore next */
    hasLiveStream(element) {
        return element && element.hasLiveStream === true;
    }
    /* istanbul ignore next */
    setParams(eventType, regionId, branchId) {
        this.selectedType = eventType;
        /* istanbul ignore next */
        if (regionId && branchId) {
            /* istanbul ignore next */
            this.racingStore.setParams(regionId, branchId);
        }
    }
}
__decorate([
    computed,
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [])
], RacingCurrentEventsData.prototype, "branchViewLeagueEvents", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number, Number, Number]),
    __metadata("design:returntype", void 0)
], RacingCurrentEventsData.prototype, "setParams", null);
//# sourceMappingURL=RacingCurrentEventsData.js.map